import { Skeleton } from '@/components/ui/skeleton'

const StudentDashboardSkeleton: React.FC = () => {
  return (
    <div className='grid grid-cols-[repeat(auto-fill,_minmax(224px,_1fr))] xl:grid-cols-5 gap-9 mt-7 ml-1'>
      {Array(10)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className='flex items-center justify-center aspect-[1.4] bg-muted rounded-[0.88rem] animate-pulse'
          >
            <div className='h-full w-full flex items-center justify-center flex-col'>
              <div className='flex items-center justify-end w-full h-1/4 p-3 gap-2'>
                <Skeleton className='h-5 w-20 rounded-full' />
              </div>
              <div className='w-full h-full flex flex-col items-center justify-center pb-6 gap-2'>
                <Skeleton className='h-5 w-32' />
                <Skeleton className='h-9 w-28 rounded-md mt-2' />
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}

export default StudentDashboardSkeleton
